<template>
    <div class="dashboard-window" v-if="data">
        <div class="dashboard-window-header">
            <div class="window-header__title">
                Топ товаров
            </div>
        </div>
        <div class="dashboard-window-body" :class="{ expanded: isExpanded }">
            <div
                class="dashboard-window-body-item"
                v-for="product in data.slice(0, 6)"
                :key="product.id"
            >
                <div v-if="product.image" class="dashboard-window-body-item__img" >
                    <img :src="product.image" :alt="product.name">
                </div>
                <div v-else class="dashboard-window-body-item__img empty"></div>
                <p>{{ product.name }}</p>
                <span>Продано: {{ formatNumber(product.revenue) }}</span>
            </div>
            <div class="dashboard-window-body-item__more" @click="toggleBlocks">
                <svg width="36px" height="36px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="white"></rect> <path d="M17 9.5L12 14.5L7 9.5" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            </div>
        </div>
    </div>
</template>
<script>
import { formatNumber } from '@/utils/numberFormat'

export default {
    data() {
        return {
            isExpanded: false
        }
    },

    props: {
        data: {
            type: Object,
            default: null
        }
    },

    methods: {
        formatNumber,

        toggleBlocks() {
            this.isExpanded = !this.isExpanded
        }
    }
}
</script>
<style scoped lang="scss">
.dashboard-window {
    padding: 0 20px 20px 20px;
    display: flex;
    flex-direction: column;
    font-family: 'SFProDisplay', sans-serif;
    height: 100%;
    background: var(--color-white);
    border-radius: 16px;
    border: 1px solid #F5F5F5;
    overflow: hidden;
    @media only screen and (max-width: 425px) {
        padding-bottom: 8px;
    }
    
    &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 700;
        height: 64px;
    }

    &-body {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 16px;
        @media only screen and  (max-width: 425px) {
            grid-template-columns: 1fr;
        }
        &-item {
            padding: 10px 14px;
            display: grid;
            grid-template-columns: 50px 1fr;
            grid-column-gap: 12px;
            grid-row-gap: 4px;
            align-items: center;
            background: #FAFAFA;
            border-radius: 16px;
            &__img {
                grid-row: 1 / 3;
                min-width: 50px;
                min-height: 50px;
                max-width: 50px;
                max-height: 50px;
                border-radius: 50%;
                & img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
                &.empty {
                    background: #969696;
                }
            }
            & p {
                font-size: 16px;
                font-weight: 600;
            }
            & span {
                color: #737373;
            }
            &__more {
                display: none;
                align-items: center;
                justify-content: center;
                transition: 0.3s;
                @media only screen and (max-width: 425px) {
                    display: flex;
                }
            }
        }
    }
}

@media only screen and (max-width: 425px) {
    .dashboard-window-body-item:nth-child(n+4) {
        display: none;
    }

    .dashboard-window-body.expanded .dashboard-window-body-item {
        display: grid;
    }

    .dashboard-window-body.expanded .dashboard-window-body-item__more svg {
        transform: rotate(180deg);
    }
}
</style>